import type { Tone } from "../../components/ui";
import type { CarrierStatus } from "../../features/shipments/carrierTracking";
import type {
  ShipmentEventType,
  ShipmentStage,
} from "../../features/shipments/types";
import type { StatusId } from "../lite/components/Sidebar/statusMeta";
import type { ResolvedStatus } from "../admin/components/sections/trackingLinks/utils/helpers";

export const STAGE_TONES = {
  pending: "warning",
  transit: "info",
  delivered: "success",
  incident: "error",
} as const satisfies Record<ShipmentStage, Tone>;

export const STAGE_DOTS = {
  pending: "bg-warning",
  transit: "bg-info",
  delivered: "bg-success",
  incident: "bg-error",
} as const satisfies Record<ShipmentStage, string>;

export const EVENT_TYPE_TONES = {
  pickup: "info",
  transit: "info",
  intermediate: "warning",
  warehouse: "info",
  customs: "info",
  last_mile: "info",
  delivered: "success",
  incident: "error",
} as const satisfies Record<ShipmentEventType, Tone>;

export const eventTypeTone = (eventType: ShipmentEventType | null): Tone =>
  eventType ? EVENT_TYPE_TONES[eventType] : "neutral";

export const UNIT_STATUS_TONES = {
  driving: "success",
  ralenti: "warning",
  stopped: "error",
  offline: "neutral",
} as const satisfies Record<StatusId, Tone>;

export const TRACKING_LINK_TONES = {
  active: "success",
  inactive: "error",
  expired: "neutral",
  pending: "warning",
  unknown: "neutral",
} as const satisfies Record<ResolvedStatus, Tone>;

/** Estatus normalizado de la paquetería (17TRACK). Lo desconocido cae a neutral. */
export const CARRIER_STATUS_TONES = {
  pending: "warning",
  info_received: "info",
  in_transit: "info",
  out_for_delivery: "info",
  delivered: "success",
  exception: "error",
  expired: "neutral",
  not_found: "neutral",
} as const satisfies Record<CarrierStatus, Tone>;
